import API from '@aws-amplify/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../../../i18n';
import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { ProtectedRouteContext } from '../../../Context';

import './Radio.scss';

export default function Radio(props) {
    //TODO emit my saving status to parent component

    const question = props.question;
    const shouldShowErrors = props.shouldShowErrors;
    const disabled = props.disabled;
    const appInstanceId = props.appInstanceId;
    const answerUpdated = props.answerUpdated;
    const previouslyChosen = question.chosenOptions && question.chosenOptions.length > 0 ? question.chosenOptions[0] : undefined;

    const [t] = useTranslation();
    const { userSettings } = useContext(ProtectedRouteContext);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );
    const [chosenVal, setChosenVal] = useState(previouslyChosen);
    const [saving, setSaving] = useState(false);

    question.isValid = !!previouslyChosen;

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    const onValueChange = async (event) => {
        const newChosenId = parseInt(event.target.value);
        setSaving(true);
        try {
            var updateAnswerResponse = await API.put('ShipyardAPI', `/application/${appInstanceId}/answer/${question.id}`, {
                body: { responseIds: [newChosenId] },
            });
        } catch (apiErr) {
            toast.error(t('General.AjaxError'));
            return;
        }

        if (!updateAnswerResponse.success) {
            toast.error(t('General.AjaxError'));
            return;
        }

        question.chosenOptions = [newChosenId];
        question.isValid = true;
        answerUpdated();
        setChosenVal(newChosenId);
        setSaving(false);
    };

    return (
        <div
            className={'question-wrapper radio' + (!question.isValid && shouldShowErrors ? ' invalid' : '') + (disabled ? ' disabled' : '')}
            role="radiogroup"
        >
            <fieldset>
                <legend className={question.minResponseRequired > 0 ? 'required' : null}>
                    <ReactMarkdown
                        children={question.text[lang]}
                        linkTarget="_blank"
                    />
                </legend>

                <span className="invalid-reason">
                    {question.isValid ? '' : typeof question.invalidReason === 'string' ? t(question.invalidReason) : ''}
                </span>

                {question.options.map((option) => {
                    let isSelected = chosenVal === option.id;
                    return (
                        <div
                            className="radio-option"
                            key={option.id}
                        >
                            {saving ? (
                                <div className="saving">
                                    <FontAwesomeIcon icon={faSpinner} />
                                </div>
                            ) : null}
                            {!saving ? (
                                <div className="input-wrap">
                                    <input
                                        type="radio"
                                        id={`quest-${question.id}-opt-${option.id}`}
                                        name={'quest-opt-' + question.id}
                                        checked={isSelected}
                                        disabled={saving}
                                        onChange={onValueChange}
                                        value={option.id}
                                    />
                                </div>
                            ) : null}
                            <label htmlFor={`quest-${question.id}-opt-${option.id}`}>
                                <ReactMarkdown
                                    children={option.text[lang]}
                                    linkTarget="_blank"
                                />
                            </label>
                        </div>
                    );
                })}
            </fieldset>
        </div>
    );
}
